<template>
    <div>
        {{clientTime}}
    </div>
</template>
<script>

export default {
    name: 'servertime',
    data(){
        return {
        }
    },
    props:{
        clientTime: String
    },
    methods: {

    }
};
</script>